import { ChipProps } from "./Chip.types";
import * as Styled from "./Chip.styles";

export const Chip = ({ children, variant }: ChipProps) => {
  return <Styled.Wrapper variant={variant}>{children}</Styled.Wrapper>;
};
